export const MODAL_SHOW = 'MODAL_SHOW';
export const MODAL_HIDE = 'MODAL_HIDE';

export const modalShow = id => ({
    type: MODAL_SHOW,
    payload: id,
})

export const modalHide = id => ({
    type: MODAL_HIDE,
    payload: id,
})